import SearchTag from "#app/pages/IncomeAndExpenses/components/BaseOperationList/form/SearchTag";
import {Plus, TagText} from "#app/pages/IncomeAndExpenses/components/BaseOperationList/style";
import React, {useState} from "react";

export const TagDisplay = ({item, subcategoryType, tags}) => {
    const [editTag, setEditTag] = useState(false);

    // Формируем строку для tooltip
    const tooltipContent = item.tag_items.map(tag => tag.label).join(', ');

    return item.editable && editTag ? (
        <SearchTag item={item} subcategoryType={subcategoryType} tags={tags}
                   finishEdit={() => setEditTag(false)}/>
    ) : (
        item.tag_items.length > 0 ? (
            <TagText
                id={`edit-tag-${item.id}`}
                onClick={() => setEditTag(true)}
                data-tooltip-content={tooltipContent}
            >
                {item.tag_items.length === 1
                    ? item.tag_items[0].label
                    : `${item.tag_items[0].label} +${item.tag_items.length - 1}`
                }
            </TagText>
        ) : (
            <Plus id={`edit-tag-${item.id}`} onClick={() => setEditTag(true)} />
        )
    );
};